import React from "react";

export const AutoApplyIcon: React.FC<{ className?: string; size?: number }> = ({
  className,
  size = 20,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.2105 14.3462C16.2105 12.6468 14.7967 11.2692 13.0526 11.2692C11.3086 11.2692 9.89473 12.6468 9.89473 14.3462C9.89473 16.0455 11.3086 17.4231 13.0526 17.4231V18C10.9816 18 9.30263 16.3641 9.30263 14.3462C9.30263 12.3282 10.9816 10.6923 13.0526 10.6923C15.1237 10.6923 16.8026 12.3282 16.8026 14.3462C16.8026 16.3641 15.1237 18 13.0526 18V17.4231C14.7967 17.4231 16.2105 16.0455 16.2105 14.3462Z"
      fill="#E747B3"
    />
    <path
      d="M15.812 3.05183C15.9395 3.01572 16.1593 2.96318 16.3896 3.03812C16.6592 3.12587 16.8708 3.33207 16.9609 3.59476C17.0378 3.81911 16.9839 4.0333 16.9468 4.15759C16.9072 4.29049 16.8427 4.45148 16.7737 4.62353L14.5054 10.2866C14.155 10.1886 13.7874 10.131 13.4079 10.1184L15.2935 5.41041L9.05363 11.4905L9.3599 12.2578C9.08319 12.7049 8.88526 13.2036 8.78514 13.7356L8.00608 11.7834C8.00404 11.7783 8.0021 11.7735 8.0003 11.769C7.99565 11.7672 7.99071 11.7653 7.98545 11.7633L3.07476 9.9026C2.87755 9.82789 2.69722 9.75961 2.56014 9.69377C2.43768 9.63494 2.22145 9.52239 2.10238 9.29976C1.96611 9.04492 1.96584 8.74121 2.1018 8.48621C2.22061 8.26341 2.43679 8.1506 2.55918 8.09164C2.69619 8.02563 2.87647 7.95718 3.07361 7.88224L15.3338 3.22047C15.5103 3.15331 15.6756 3.09043 15.812 3.05183ZM3.48916 8.85937C3.45877 8.87092 3.43001 8.88185 3.40281 8.89223C3.43002 8.90258 3.45876 8.91358 3.48916 8.9251L8.28613 10.7426L14.5262 4.66278L3.48916 8.85937Z"
      fill="#2B244C"
    />
  </svg>
);
